<!-- @format -->
<template>
    <div class="gst-manage-booking-view d-flex flex-column">
        <DataLoading
            v-if="bookingLoading"
            class="mt-5 mb-5 pt-5 pb-5" />
        <router-view
            v-else
            :key="bookingNeedsUpdate" />
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import EntityNotFoundRedirect404 from '@core/mixins/EntityNotFoundRedirect404';
import DataLoading from '@core/shared/components/loading/DataLoading.vue';
import EventFlowMixin from '@tenant/app/mixins/EventFlowMixin';
import tmEventConstants from '@tenant/app/utils/constants/event';
import StatusMixin from './mixins/StatusMixin';

export default {
    name: 'TheManageBookingView',
    components: {
        DataLoading,
    },
    mixins: [EntityNotFoundRedirect404, EventFlowMixin, StatusMixin],
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking.theManageBooking',
    },
    testIdOptions: {
        keyPrefix: 'manageBooking',
    },
    computed: {
        ...mapState({
            booking: (state) => state.booking.booking,
            bookingNeedsUpdate: (state) => state.booking.needsUpdate,
        }),
        ...mapGetters({
            bookingLoading: 'booking/loading',
        }),
    },
    methods: {
        ...mapActions({
            getBooking: 'booking/get',
            setEventFlow: `events/setEventFlow`,
        }),
    },
    async beforeRouteUpdate(to, from, next) {
        this.bookingNeedsUpdate && (await this.getBooking({ cartId: to.params.id }));
        next();
    },
    async beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            try {
                const response = await vm.getBooking({ cartId: to.params.id });
                if (!response.success) {
                    vm._goToNotFoundPage();
                    next();
                }
            } catch (e) {
                vm._goToNotFoundPage();
                next();
            }
        });
    },
    created() {
        this.setEventFlow({ flow: tmEventConstants.FLOWS.MANAGE_BOOKING });
    },
};
</script>

<style lang="scss">
@import '@scssMixins';
@import '@scssVariables';

.gst-manage-booking-view {
    min-height: calc(var(--vh, 1vh) * 82);
    @include mobile-only {
        min-height: calc(var(--vh, 1vh) * 92);
    }
}
</style>
